import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/stop.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm stop [-- <args>]
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/stop.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`This runs a predefined command specified in the "stop" property of a
package's "scripts" object.`}</p>
    <p>{`Unlike with `}<a parentName="p" {...{
        "href": "/cli/v8/commands/npm-start"
      }}>{`npm start`}</a>{`, there is no default script
that will run if the `}<inlineCode parentName="p">{`"stop"`}</inlineCode>{` property is not defined.`}</p>
    <h3>{`Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "scripts": {
    "stop": "node bar.js"
  }
}
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm stop

> npm@x.x.x stop
> node bar.js

(bar.js output would be here)

`}</code></pre>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`ignore-scripts`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If true, npm does not run scripts specified in package.json files.`}</p>
    <p>{`Note that commands explicitly intended to run a particular script, such as
`}<inlineCode parentName="p">{`npm start`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm stop`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm restart`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm test`}</inlineCode>{`, and `}<inlineCode parentName="p">{`npm run-script`}</inlineCode>{`
will still run their intended script if `}<inlineCode parentName="p">{`ignore-scripts`}</inlineCode>{` is set, but they
will `}<em parentName="p">{`not`}</em>{` run any pre- or post-scripts.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`script-shell`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: '/bin/sh' on POSIX systems, 'cmd.exe' on Windows`}</li>
      <li parentName="ul">{`Type: null or String`}</li>
    </ul>
    <p>{`The shell to use for scripts run with the `}<inlineCode parentName="p">{`npm exec`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm run`}</inlineCode>{` and `}<inlineCode parentName="p">{`npm
init <package-spec>`}</inlineCode>{` commands.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-run-script"
        }}>{`npm run-script`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/scripts"
        }}>{`npm scripts`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-test"
        }}>{`npm test`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-start"
        }}>{`npm start`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-restart"
        }}>{`npm restart`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      